import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ClientDownloadService {

    /**
     * Öffnet ein PDF, das nur über einen authentifizierten Backend-Endpoint erreichbar ist,
     * in einem neuen Browser-Tab.
     *
     * @param pdfBlob$ vom Aufrufer bereitgestellter Observable, üblicherweise aus einem
     *                 generierten API-Service mit responseType 'blob'.
     * @param onError optionaler Fehler-Callback (z.B. um eine Meldung anzuzeigen).
     */
    public openPdfInNewTab(pdfBlob$: Observable<Blob>, onError?: (err: unknown) => void): void {
        const previewWindow = window.open('', '_blank');

        pdfBlob$.subscribe({
            next: (pdfBlob: Blob) => {
                const blobUrl = URL.createObjectURL(
                    new Blob([pdfBlob], { type: 'application/pdf' })
                );

                if (previewWindow) {
                    previewWindow.location.href = blobUrl;
                } else {
                    // Pop-up wurde blockiert -> Fallback im aktuellen Tab
                    window.location.href = blobUrl;
                }
            },
            error: err => {
                if (previewWindow) {
                    previewWindow.close();
                }
                onError?.(err);
            }
        });
    }

}
